var React = require('react');

function GreenPenIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.256 0h-.344L7.587 1.327l2.087 2.089L11 2.089v-.344L9.256 0zM.958 7.964L0 11l3.032-.959 5.77-5.777-2.087-2.089L.958 7.964z","fill":"#269c74","fillRule":"evenodd"}));
}

GreenPenIconInline.defaultProps = {"width":"11","height":"11","xmlnsV":"https://vecta.io/nano"};

module.exports = GreenPenIconInline;

GreenPenIconInline.default = GreenPenIconInline;
